<template>
    <div class="opui-row" v-if="trigger.event">
        <div class="opui-col">
            <label>{{ $e('Select post type') }}</label>
            <RichSelect
                    v-if="postType"
                    v-model="postType"
                    modelValue="postType"
                    :settings="postTypeSelectSettings"
                    :ajaxUrl="postTypeSelectUrl"
                    :placeholder="'Select post type'"
                    @select="postTypeSelected"
            >
                <option :value="postType" selected v-if="postType">
                    {{ postTypeTitle ? postTypeTitle : postType }}
                </option>
            </RichSelect>
            <!-- <p><small>{{ postTypeSelectSettings }}</small></p>
            <p><small>{{ postType }}</small></p> -->
        </div>

        <div class="opui-col" v-if="postType && postType !== 'all'">
            <label>{{ title }}</label>
            <RichSelect
                    v-if="postId"
                    v-model="postId"
                    modelValue="postId"
                    :settings="pageSelectSettings"
                    :ajaxUrl="pageSelectUrl"
                    :placeholder="'Select post'"
                    @select="pageSelected"
            >
                <option :value="postId" selected v-if="postId">
                    {{ postTitle ? postTitle : postId }}
                </option>
            </RichSelect>
            <!-- <p><small>{{ pageSelectSettings }}</small></p>
            <p><small>{{ postId }}</small></p> -->
        </div>
    </div>

    <div class="opui-row">
        <div class="opui-col" v-if="this.postId && this.postId !== 'all'">
            <label>{{ $e('Choose form') }}</label>
            <RichSelect
                    v-if="formId"
                    v-model="formId"
                    modelValue="trigger.settings.form_id"
                    :settings="formSelectSettings"
                    :ajaxUrl="formSelectUrl"
                    :placeholder="'Select form'"
                    @select="formSelected"
            >
                <option :value="formId" selected v-if="formId">
                    {{ formTitle ? formTitle : formId }}
                </option>
            </RichSelect>
<!--            <p><small>{{ formSelectSettings }}</small></p>-->
<!--            <p><small>{{ formId }}</small></p>-->
        </div>
    </div>
<!--    <p><small>{{ formType }}</small></p>-->
<!--    <p><small>{{ trigger.settings }}</small></p>-->
<!--    <p><small>{{ postType }} / {{ postId }} / {{ formId }}</small></p>-->

    <div class="opui-form-group" v-if="trigger.settings && trigger.settings.fields">
        <label>
            <a href="#" @click.prevent="toggleFields">
                {{ $e('Fields') }}
                <small>({{ trigger.settings.fields.length ? trigger.settings.fields.length : 0 }} fields)</small>
            </a>
        </label>

        <div class="opui-row" v-if="showFields">
            <div class="opui-col">
                <div class="opfl-field-map-item opui-row" v-for="(mapItem, index) in this.trigger.settings.fields">
                    <div class="opui-col">
                        <input type="text" v-model="mapItem.id" class="opui-form-control" required />
                    </div>

                    <div class="opui-col">
                        <select v-model="mapItem.type" class="opui-form-control">
                            <optgroup label="Generic">
                                <option value="number">{{ $e('Number') }}</option>
                                <option value="text">{{ $e('Text') }}</option>
                                <option value="text">{{ $e('Boolean') }}</option>
                            </optgroup>
                            <optgroup label="Dynamic">
                                <option value="dynamic/email">{{ $e('Email') }}</option>
                                <option value="dynamic/post">{{ $e('WordPress Post') }}</option>
                                <option value="dynamic/user">{{ $e('Registered User') }}</option>
                            </optgroup>
                        </select>
                    </div>

                    <div class="opui-col-1">
                        <a href="#" @click.prevent="removeField(index)" class="opui-btn opui-btn-link"><i class="opui-fa opui-fa-trash opui-text-gray-400"></i></a>
                    </div>
                </div>

                <div class="opui-row">
                    <div class="opui-col">
                        <a href="#" @click.prevent="addField" class="opui-btn opui-btn-success opui-btn-xs">+ {{ $e('Add new') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"

export default {
    components: { RichSelect },
    props: {
        title:    { type: String, required: true },
        formType: { type: String, required: true },
        trigger:  { type: Object, required: true },
    },
    data() {
        return {
            postType:      'page',
            postTypeTitle: 'Pages',
            postId:        'all',
            postTitle:     '- All -',
            formId:        'all',
            formTitle:     '- All -',
            showFields:    false,
        }
    },
    created() {
        if (! this.trigger.settings)        this.trigger.settings        = {}
        if (! this.trigger.settings.fields) this.trigger.settings.fields = []

        if (this.trigger.event && this.trigger.settings) {
            this.postType      = this.trigger.settings.post_type + ''
            this.postTypeTitle = this.trigger.settings.post_type_title
            this.postId        = this.trigger.settings.page_id
            this.postTitle     = this.trigger.settings.page_title
            this.formId        = this.trigger.settings.form_id
            this.formTitle     = this.trigger.settings.form_title
        }
    },
    computed: {
        postTypeSelectSettings() {
            return { ajax: { url: this.postTypeSelectUrl, dataType: 'json' } }
        },

        postTypeSelectUrl() {
            return this.restUrl('flow/post-types')
        },

       pageSelectSettings() {
            return { ajax: { url: this.pageSelectUrl, dataType: 'json' } }
        },

        pageSelectUrl() {
            return this.restUrl('flow/pages-with-forms?type=' + this.formType + '&post_type=' + this.postType)
        },

        formSelectSettings() {
            return { ajax: { url: this.formSelectUrl, dataType: 'json' } }
        },

        formSelectUrl() {
            return this.restUrl('flow/page-forms/' + this.postId) + '?type=' + this.formType
        },
    },
    methods: {
        /**
         * Update the selected text
         */
        postTypeSelected(selected) {
            this.postId        = 'all'
            this.postTitle     = '- All -'
            this.formId        = 'all'
            this.formTitle     = '- All -'
            this.postTypeTitle = selected.text

            this.setTriggerValues()
        },

        /**
         * Update the selected text
         */
        pageSelected(selected) {
            this.formId    = 'all'
            this.formTitle = '- All -'
            this.postTitle = selected.text

            this.setTriggerValues()
        },

        /**
         * Update the selected text
         */
        formSelected(selected) {
            this.formTitle = selected.text

            this.setTriggerValues()
        },

        /**
         * Add new field to the field map
         */
        addField() {
            this.trigger.settings.fields.push({
                id: '',
                label: '',
                type: 'text',
                value: '',
            })
        },

        /**
         * Remove a field from the list
         * @param index
         */
        removeField(index) {
            this.trigger.settings.fields.splice(index, 1)
        },

        toggleFields() {
            this.showFields = ! this.showFields
        },

        setTriggerValues() {
            this.trigger.settings.post_type      = this.postType
            this.trigger.settings.post_type_title = this.postTypeTitle
            this.trigger.settings.page_id         = this.postId
            this.trigger.settings.page_title      = this.postTitle
            this.trigger.settings.form_id         = this.formId
            this.trigger.settings.form_title      = this.formTitle
        }
    }
}
</script>
